var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-list"},[_c('div',{staticClass:"results-count"},[_c('p',[_vm._v(_vm._s(_vm.t('found_items_count'))+" "),_c('span',[_vm._v(_vm._s(_vm.found))])])]),_vm._v(" "),_c('div',{staticClass:"bikes matched"},[_c('h3',{staticClass:"serie-logo"}),_vm._v(" "),_c('ul',{staticClass:"products"},_vm._l((_vm.bikes),function(product,product_index){return _c('li',{key:product_index,class:{
              'matched': true,
              'bike' : true,
              'kind-f': product.gender === 'F',
              'kind-m': product.gender === 'M',
              'kind-k': product.gender === 'K',
              }},[_c('item',{attrs:{"product":product}})],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"accessories matched"},[_c('h3',{staticClass:"serie-logo"}),_vm._v(" "),_c('ul',{staticClass:"products"},_vm._l((_vm.accessories),function(product,product_index){return _c('li',{key:product_index,class:{
              'matched': true,
              'accessory' : true,
              'kind-f': product.gender === 'F',
              'kind-m': product.gender === 'M',
              'kind-k': product.gender === 'K',
              'kind-u': product.gender === 'U',
              }},[_c('item',{attrs:{"product":product}})],1)}),0)]),_vm._v(" "),(_vm.found === 0)?_c('div',{attrs:{"id":"not-found"}},[_c('h1',[_vm._v(_vm._s(_vm.t('nothing_found')))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bcb93bd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/Results.vue
// module id = null
// module chunks = 